<template>
    <div class="my-2">
            <v-row no-gutters class="attach-item" v-for="(item, index) in items">
                <v-col cols="auto">
                    <div v-if="isImage(item.requestDocFile)" class="imageContainer">
                        <expandable-image
                                width="150%"
                                :src="$root.docsUrl+item.requestDocFile"
                                :alt="item.requestDocName"
                        />
                    </div>
                    <div v-else class="imageContainer">
                        <div class="docFormat">{{item.requestDocName.split('.')[1]}}</div>
                        <a :href="$root.docsUrl+item.requestDocFile" :download="item.requestDocName" target="_blank">
                            <span class="text-truncate docName">{{item.requestDocName}}</span>
                        </a>
                    </div>
                </v-col>
                <v-col cols="auto" align-self="center">
                    <div class="text-truncate attach-name">{{item.requestDocName}}</div>
                </v-col>
                <v-col cols="auto" align-self="center">
                    <v-btn class="dowload-btn" @click="downloadFile(item)">
                        <icon iconName="download"></icon>
                    </v-btn>
                </v-col>

            </v-row>
    </div>
</template>

<script>
    import icon from '../icons.vue'
    export default {
        name: "DetailsRequestAttachments",
        components:{icon},
        props:{
            items:Array
        },
        methods:{
            isImage(url){
                var regStr= /\.jpg$/;
                return new RegExp(regStr, 'ig').test(url);
            },

            downloadFile(doc){
                var link = document.createElement("a");
                link.target="_blank"
                link.href= `${this.$root.docsUrl+doc.requestDocFile}`;
                link.download= doc.requestDocName;
                link.click();
            }

        }
    }
</script>

<style scoped>

    .attach-item{

        background: #EFF2FC;
        border-radius: 4px;
        margin-top: 10px;
    }
    .imageContainer{
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
        display: flex;
        align-items: center;
        overflow: hidden;
        border: 1px solid #D3DAE1;
    }
    .docFormat{
        margin: 0 auto 35px auto;
        font-size:30px;
        color:#ACB7C0;
        text-align: center;
    }
    .attach-name{
        font-weight: 500;
        font-size: 14px;
        line-height: 24px;
        color: #000000;
        margin: 10px;
    }
    .docName{
        padding: 2px;
        text-align: center;
        width: 94px; position: absolute; bottom:12px; left:13px; background-color: #D3DAE1;  color:#1A2A3A
    }
    .dowload-btn{
        min-width: 40px !important;
        max-width: 40px;
        width: 40px;
        height: 40px !important;
        min-height: 40px;
        max-height: 40px;
    }
    @media screen and (max-width: 1264px) {
        .attach-item {
            width: 160px;
            height: 50px;

        }
        .imageContainer {
            height: 50px;
            width: 50px;
        }
        .attach-name{
            width:60px;
            font-size: 12px;
            line-height: 20px;
            margin: 5px;
        }

        .dowload-btn{
            min-width: 30px !important;
            max-width: 30px;
            width: 30px;
            height: 30px !important;
            min-height: 30px;
            max-height: 30px;
        }

    }
    @media screen and (max-width: 1900px) and (min-width: 1264px) {
        .attach-item {
            width: 225px;
            height: 55px;

        }
        .imageContainer {
            height: 55px;
            width: 55px;
        }
        .attach-name{
            width:100px;
        }
    }
    @media screen and (min-width: 1900px) {
        .attach-item {
            width: 304px;
            height: 60px;
        }

        .imageContainer {
            height: 60px;
            width: 60px;
        }
        .attach-name{
            width:170px;
        }
    }
</style>